// noinspection JSUnusedGlobalSymbols

import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store";
import { del, get, http, post, put } from "@/utils/request";
import * as echarts from 'echarts';
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import moment from "moment";
import "./components/index.js";
// 导入v-viewer插件
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
// 导入复制插件
import VueClipboard from "vue-clipboard2";
// 导入i18n
import i18n from "./lang/index";

Vue.use(Viewer);
Vue.use(preview, { tapToToggleControls: true, arrowEl: true });

Vue.use(VueClipboard);

/**
 * 图片懒加载
 * 配置项error，loading都可以更改
 */
// import VueLazyload from "vue-lazyload";
//
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: "https://t8.baidu.com/it/u=1484500186,1503043093&fm=79&app=86&size=h300&n=0&g=4n&f=jpeg?sec=1589614299&t=dc081e535468869ff5ee701a76abe5dc",
//   loading: "https://t9.baidu.com/it/u=1307125826,3433407105&fm=79&app=86&size=h300&n=0&g=4n&f=jpeg?sec=1589614299&t=02fe9319044493b85004c0b15c8739e8",
//   attempt: 1
// });
Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$put = put;
Vue.prototype.$del = del;
Vue.prototype.$http = http;
Vue.prototype.$echarts = echarts;
Vue.use(Antd);

new Vue({
  router,
  store,
  i18n,
  data() {
    return {
      dateFormat: 'YYYY-MM-DD'
    }
  },
  render: h => h(App)
}).$mount("#app");
